import english_messages from './en-gb';
import german_messages from './de-at';

export default {
    en: english_messages,
    de: german_messages
};
